export default __webpack_public_path__ + "static/media/saleshandy-logo.f78881a2.svg";